import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerFooter,
  DrawerRoot,
  DrawerTitle,
  DrawerTrigger,
} from "../ui/drawer"

export default function ReusableDrawer({
  isOpen,
  bgColor,
  size = 'xs',
  titleStyle,
  onClose,
  title,
  bodyContent,
  bodyStyle,
  footerStyle,
  footerContent,
  placement
}) {
  const handleCancel = () => {
    onClose()
  }

  return(
    <DrawerRoot open={isOpen} placement={placement} onOpenChange={handleCancel} size={size}>
      <DrawerBackdrop />
      <DrawerTrigger />
      <DrawerContent bg={bgColor}>
        <DrawerCloseTrigger />
        <DrawerTitle
          p={4}
          textStyle='xl'
          className={titleStyle}
        >
          {title}
        </DrawerTitle>
        <DrawerBody className={bodyStyle}>

          {bodyContent}
        </DrawerBody>
        <DrawerFooter className={footerStyle}>
          {footerContent}
        </DrawerFooter>
      </DrawerContent>
    </DrawerRoot>
  )
}